import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const useStylesBootstrap = makeStyles(theme => ({
    arrow: {
        position: "absolute",
        fontSize: 6,
        width: "3em",
        height: "3em",
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: 0,
            height: 0,
            borderStyle: "solid",
            borderColor: 'lightgrey'
        }
    },
    tooltip: {
        position: "relative",
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        color: theme.palette.common.black,
        fontSize: 16,
        maxWidth: 'none'
    },
    tooltipPlacementLeft: {
        margin: "0 8px"
    },
    tooltipPlacementRight: {
        margin: "0 8px"
    },
    tooltipPlacementTop: {
        margin: "8px 0"
    },
    tooltipPlacementBottom: {
        margin: "8px 0"
    }
}));

function CustomTooltip(props) {
    const { arrow, ...classes } = useStylesBootstrap();

    return (
        <Tooltip
            classes={classes}
            enterDelay={props.enterDelay ? props.enterDelay : 500}
            leaveDelay={props.leaveDelay ? props.leaveDelay : 250}
            enterNextDelay={500}
            arrow
            {...props}
            title={
                <React.Fragment>
                    {props.titletext}
                </React.Fragment>
            }
        />
    );
}

export default function CustomizedTooltips(props) {
    return (
        props.titletext === ''
            ? props.jsx
            : <CustomTooltip {...props} >
                {props.jsx}
            </CustomTooltip>
    );
}